import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./styles.css";
import { IconArrowLeft, IconWhatsApp } from "../icons/Icons";

const WHATSAPP_URL = "https://wa.me/640997403";

function SubLayout({ icon: Icon, title, intro, children, centered = false, wide = false }) {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const contentClass = [
        "subpage-content",
        centered ? "is-centered" : "",
        wide ? "is-wide" : "",
    ]
        .filter(Boolean)
        .join(" ");

    return (
        <div className="subpage">
            <header className="subpage-bar">
                <Link to="/" className="back-link" aria-label="Volver al inicio">
                    <IconArrowLeft className="back-icon" />
                </Link>
                <span className="subpage-bar-title">SUBLIME HAIR SALON</span>
                <a
                    href={WHATSAPP_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bar-wa"
                    aria-label="Contactar por WhatsApp"
                >
                    <svg className="wa-icon" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="24" cy="24" r="22" fill="none" stroke="#fff" strokeWidth="1.3" />
                        <IconWhatsApp x="13" y="11.5" width="22" height="25" />
                    </svg>
                </a>
            </header>

            <main className={contentClass}>
                <div className="subpage-head">
                    {Icon && <Icon className="subpage-head-icon" />}
                    <h1 className="subpage-title">{title}</h1>
                </div>
                {intro && <p className="subpage-intro">{intro}</p>}
                {children}
            </main>
        </div>
    );
}

export default SubLayout;
